<script lang="ts">
  let {
    bars,
    height = 180,
    title,
    sub,
    footLeft,
    footRight,
  }: {
    bars: number[];
    height?: number;
    title?: string;
    sub?: string;
    footLeft?: string;
    footRight?: string;
  } = $props();

  const W = 540;
  const H = $derived(height);
  const max = $derived(Math.max(...bars, 1));
  const barW = $derived(bars.length > 0 ? W / bars.length : 0);
</script>

<div class="rounded-xl border border-[var(--color-border-3)] bg-white p-4">
  {#if title}
    <div class="flex items-center justify-between mb-3">
      <div>
        <div class="text-[13px] font-bold">{title}</div>
        {#if sub}<div class="text-[10.5px] text-[var(--color-text-muted)] mt-0.5">{sub}</div>{/if}
      </div>
    </div>
  {/if}

  <svg viewBox="0 0 {W} {H}" preserveAspectRatio="none" class="block w-full" style="height: {H}px">
    <g stroke="#E5E1EE" stroke-width="0.5">
      <line x1="0" y1={H * 0.2} x2={W} y2={H * 0.2} />
      <line x1="0" y1={H * 0.4} x2={W} y2={H * 0.4} />
      <line x1="0" y1={H * 0.6} x2={W} y2={H * 0.6} />
      <line x1="0" y1={H * 0.8} x2={W} y2={H * 0.8} />
    </g>

    {#each bars as v, i (i)}
      {@const h = (v / max) * (H - 16)}
      <rect
        x={i * barW + barW * 0.15}
        y={H - h}
        width={barW * 0.7}
        height={h}
        rx={2}
        fill={i === bars.length - 1 ? '#7B4FBE' : '#9B6FDE'}
      />
    {/each}
  </svg>

  {#if footLeft || footRight}
    <div class="flex items-center justify-between mt-2.5 pt-2.5 border-t border-[var(--color-border-3)] text-[11px] text-[var(--color-text-muted)]">
      {#if footLeft}<div class="flex items-center gap-2"><span class="inline-block h-2 w-2 rounded-full" style="background: var(--color-pu-2)"></span> {footLeft}</div>{/if}
      {#if footRight}<div class="ml-auto">{footRight}</div>{/if}
    </div>
  {/if}
</div>
